var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49993 6.99986C5.88092 6.99986 6.99986 5.88051 6.99986 4.49993C6.99986 3.11935 5.88092 2 4.49993 2C3.11895 2 2 3.11935 2 4.49993C2 5.88051 3.11895 6.99986 4.49993 6.99986ZM4.49993 5.49986C5.05249 5.49986 5.50007 5.05229 5.50007 4.49993C5.50007 3.94758 5.05249 3.5 4.49993 3.5C3.94738 3.5 3.4998 3.94758 3.4998 4.49993C3.4998 5.05229 3.94738 5.49986 4.49993 5.49986Z",
    fill: "#7B8BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97003 12.9693C2.85203 12.8511 2.78123 12.7032 2.75844 12.5496C2.72508 12.3228 2.79506 12.0833 2.97003 11.9086L11.9094 2.96962C12.2015 2.67666 12.6768 2.67666 12.9698 2.96962C13.0918 3.09169 13.1634 3.24549 13.1838 3.40438C13.2114 3.62675 13.1406 3.85928 12.9698 4.03018L4.03038 12.9693C3.94493 13.0548 3.84403 13.1154 3.73661 13.151C3.4762 13.2373 3.17754 13.1769 2.97003 12.9693Z",
    fill: "#7B8BA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5001 13.9996C12.8811 13.9996 14 12.8802 14 11.4997C14 10.1191 12.8811 8.99973 11.5001 8.99973C10.1191 8.99973 9.00014 10.1191 9.00014 11.4997C9.00014 12.8802 10.1191 13.9996 11.5001 13.9996ZM11.5001 12.4996C12.0526 12.4996 12.5002 12.052 12.5002 11.4997C12.5002 10.9473 12.0526 10.4997 11.5001 10.4997C10.9475 10.4997 10.4999 10.9473 10.4999 11.4997C10.4999 11.865 10.6961 12.1845 10.9882 12.359C11.1379 12.4483 11.3129 12.4996 11.5001 12.4996Z",
    fill: "#7B8BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.ea50622f76cadb6480bef2e483e3c02f.svg";
export { ForwardRef as ReactComponent };